// extracted by mini-css-extract-plugin
export default {"view":"src-components-common-PopupView-popup-view-module__viewXg88g"};